export function downloadBlob(blob: Blob, filename: string) {
    const aElement = document.createElement('a');
    aElement.setAttribute('download', filename);

    const href = URL.createObjectURL(blob);
    aElement.href = href;
    aElement.setAttribute('target', '_blank');
    aElement.click();
    URL.revokeObjectURL(href);
}
